import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch } from "react-redux";
import { resetNewTable } from "../../../../redux/slices/newTableSlice";


export default function CreateTable({ setAddTable }) {
    const dispatch = useDispatch()

    return(
        <Button
            onClick={() => {
                setAddTable(true)
                dispatch(resetNewTable())
            }}
            sx={{
                color: "#118EA0",
                textTransform: "none",
                justifyContent: "left",
                fontWeight: "600",
                backgroundColor: "transparent",
                fontFamily: "Averta",
                fontSize: "18px",
                lineHeight: "21px",
                "& .MuiButton-endIcon": {
                    marginLeft: "auto"
                },
                "&:hover" : {color: "#fff"}
            }}
            endIcon={<AddIcon />}
        >
            Create Table
        </Button>
    )
}